module.exports = __webpack_public_path__ + "img/cexius-logo.21737352.webp";